export default "__VITE_ASSET__CMGPnG1z__"